import { render, staticRenderFns } from "./AddressBookBox.vue?vue&type=template&id=2c9c3148&"
import script from "./AddressBookBox.vue?vue&type=script&lang=ts&"
export * from "./AddressBookBox.vue?vue&type=script&lang=ts&"
import style0 from "./AddressBookBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c9c3148')) {
      api.createRecord('2c9c3148', component.options)
    } else {
      api.reload('2c9c3148', component.options)
    }
    module.hot.accept("./AddressBookBox.vue?vue&type=template&id=2c9c3148&", function () {
      api.rerender('2c9c3148', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AddressBookBox.vue"
export default component.exports